"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function isNumber(number) {
  return typeof number === 'number' && !Number.isNaN(number);
}
var _default = exports.default = isNumber;